import { useState } from "react";

// Most call sites set a `border: "1px solid <color>"` shorthand in `style`
// and only a `borderColor` in `hoverStyle` (see pstyle.js usage throughout
// src/components/*.jsx). Merging the two as-is leaves both the shorthand
// and the longhand set at once, which React (18+, but only warns from 19)
// flags: mixing them across a rerender can leave stale values depending on
// property application order. Expand the shorthand up front so only
// longhands ever end up in the merged style object.
function expandBorderShorthand(style) {
  if (!style || typeof style.border !== "string") return style;
  const m = /^(\S+)\s+(\S+)\s+(.+)$/.exec(style.border);
  if (!m) return style;
  const { border: _border, ...rest } = style;
  return { borderWidth: m[1], borderStyle: m[2], borderColor: m[3], ...rest };
}

// Reusable stand-in for the design's `style-hover="..."` attribute: merges
// `hoverStyle` over `style` while the pointer is over the element.
export default function Hoverable({ as: Tag = "div", style, hoverStyle, onMouseEnter, onMouseLeave, children, ...props }) {
  const [hover, setHover] = useState(false);
  const base = expandBorderShorthand(style);
  return (
    <Tag
      {...props}
      style={hover ? { ...base, ...hoverStyle } : base}
      onMouseEnter={(e) => { setHover(true); onMouseEnter?.(e); }}
      onMouseLeave={(e) => { setHover(false); onMouseLeave?.(e); }}
    >
      {children}
    </Tag>
  );
}
